import Repository from './Repository';
import { StampCard, CustomerStampCard } from '@comsbi/common/src/types/models';

const resource = '/stamp_card';

export default {
  /**
   * 顧客スタンプカード解決
   */
  resolveCustomerStampCard(stampCardId: string) {
    return Repository.post(`${resource}/${stampCardId}/resolve`);
  },

  /**
   * スタンプ行動履歴取得
   */
  getCustomerDataStampCard(channelId: string, stampCardId: string, from: number, limit: number) {
    if (stampCardId != null) return Repository.post(`${resource}/history/${stampCardId}`, { params: { channelId, from, limit } });
    return Repository.post(`${resource}/history`, { params: { channelId, stampCardId, from, limit } });
  },

  /**
   * スタンプ付与(顧客スタンプカードがなければ解決してから付与)
   */
  stamp(stampCardId: string, itemKey?: string, lat: number | null = null, lng: number | null = null) {
    return Repository.post(`${resource}/${stampCardId}/stamp/${itemKey ?? ''}`, { lat, lng });
  },

  /**
   * 対象のスタンプカードの顧客スタンプをリセット
   * リセットしたスタンプ等をバックアップ領域に保存
   * @param {string} customerStampCardId
   * @param {number} maxOfStamps
   * @returns
   */
  resetCustomerStamps(customerStampCardId: string, continueWithStamps: boolean) {
    return Repository.post(`${resource}/${customerStampCardId}/reset_customer_stamps`, {
      continueWithStamps,
    });
  },
};
